<template>
<div class="cash-container">
  <div class="input-box">
    <input type="text" :placeholder="placeholder" class="input" v-model="cashVal"/>
  </div>
  <div class="btn-box">
    <Button class="button" :disabled="!cashVal" type="primary" @click.native="toCash">立即兑换</Button>
  </div>
  <div class="tips-box">
    <h5>如何获取兑换码</h5>
    <ul>
      <li>常爸会不定期举行一些活动，发放兑换码~</li>
    </ul>
  </div>
</div>
</template>
<script>
import store from '../../store'
import { Button } from 'mint-ui'
export default {
  data() {
    return {
      placeholder: "请输入8位兑换码，区分大小写",
      cashVal: null, // 兑换码
      disabled: true // 兑换按钮状态
    }
  },
  components: { Button },
  methods: {
    async toCash() {
      let res = await this.$axios.post('/api/mobile/user/vip/exchangeVip', {redeemCode: this.cashVal})
      this.$Toast("兑换成功", "top")
      // 兑换成功后自动登录一遍
      await store.login(this, 1)
      this.$router.push("/vip")
    }
  }
}
</script>
<style lang="less">
@import (reference) url(../../project.less);
.cash-container {
  padding: 1.55rem 1.72rem 0 1.72rem;
  box-sizing: border-box;
  .input-box {
    box-sizing: border-box;
    .input {
      font-size: 0.80rem;
      padding: 0.51rem 0;
      width: 100%;
      box-sizing: border-box;
    }
    .vux-1px-b;
    &:after {
      border-color: #cccccc;
    }
  }
  .btn-box {
    padding: 1.03rem 0 0.86rem 0;
    box-sizing: border-box;
    .button {
      background-color: @primary;
      height: 2.41rem;
      width: 100%;
      &:after {
        border: none;
        border-radius: 0.34rem;
      }
      &:active {
        color: #fff;
        background-color: @primary;
      }
    }
    .button[disabled="disabled"] {
      background-color: #b7b7b7;
      color: #fff;
    }
  }
  .tips-box {
    padding: 0.86rem 0;
    h5 {
      font-size: 0.86rem;
      color: @text1;
      font-weight: normal;
    }
    ul {
      padding: 0.288rem 0;
      li {
        font-size: 0.8rem;
        color: @text2;
        line-height: 1.6;
      }
    }
  }
}
</style>
